import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/Ameer-Hamza289/portfolio'
      className='link footer__link' target="_blank"
    >
    ©2023 All rights reserved - Ahsaan Ullah
    </a>
  </footer>
)

export default Footer
